const projectResourcePayload = (project, overrides = {}) => ({
	designId: project?.design?.designId || null,
	skillIds: (project?.skills || []).map(item => item.skillId),
	toolIds: (project?.tools || []).map(item => item.toolId),
	workspaceMcpIds: (project?.mcps || []).map(item => item.workspaceMcpId),
	workspaceConnectorIds: (project?.connectors || []).map(item => item.workspaceConnectorId).filter(Boolean),
	...overrides,
});

export { projectResourcePayload };
